import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const practicePatientIdStorage = createJSONStorage<string | null>(
  () => sessionStorage,
);
const practiceImageIdStorage = createJSONStorage<string | null>(
  () => sessionStorage,
);
const imageTimestampStorage = createJSONStorage<string | null>(
  () => sessionStorage,
);
export const practicePatientIdAtom = atomWithStorage(
  'jotai-practicePatientId',
  '',
  practicePatientIdStorage,
);
export const practiceImageIdAtom = atomWithStorage(
  'jotai-practiceImageId',
  '',
  practiceImageIdStorage,
);
export const displayThresholdMaxAtom = atomWithStorage(
  'jotai-displayThresholdMax',
  false,
);
export const imageViewAtom = atomWithStorage('jotai-imageView', '');
export const externalPmsSourceAtom = atomWithStorage(
  'jotai-externalPmsSource',
  '',
);
export const videaPatientIdAtom = atomWithStorage('jotai-videaPatientId', '');
export const redirectToSwitchBoardAtom = atomWithStorage(
  'jotai-redirectToSwitchBoard',
  false,
);
export const imageTimestampAtom = atomWithStorage(
  'jotai-imageTimestamp',
  '',
  imageTimestampStorage,
);

const studyDateStorage = createJSONStorage<string | null>(() => sessionStorage);
export const studyDateAtom = atomWithStorage(
  'jotai-studyDate',
  '',
  studyDateStorage,
);

// Error reason for patient match failures
export type PatientMatchErrorReason =
  | 'no_access' // Patient not found in user's accessible practices (403 or 404)
  | 'unknown'; // Other errors (network issues, server errors, etc.)

const patientMatchErrorReasonStorage = createJSONStorage<
  PatientMatchErrorReason | null
>(() => sessionStorage);
export const patientMatchErrorReasonAtom = atomWithStorage<PatientMatchErrorReason | null>(
  'jotai-patientMatchErrorReason',
  null,
  patientMatchErrorReasonStorage,
);
